import "../App.css";
import { Box, Button, CircularProgress } from "@mui/material";

function LoadingButton(props) {
  return (
    <Box
      sx={{
        m: 0,
        position: "relative",
        display: "inline-block",
        textAlign: "center",
        marginLeft: 0,
      }}
    >
      <Button {...props}>{props.children}</Button>
      {props.disabled && (
        <CircularProgress
          size={28}
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            marginTop: "-12px",
            marginLeft: "-12px",
          }}
        />
      )}
    </Box>
  );
}

export default LoadingButton;
